var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "21", height: "20", viewBox: "0 0 21 20", fill: "none" }, props),
    React.createElement("path", { d: "M4.7041 15.7452C3.98504 15.0262 4.46196 13.5165 4.09596 12.632C3.71656 11.715 2.32434 10.9769 2.32434 9.99997C2.32434 9.02301 3.71657 8.285 4.09597 7.36803C4.46197 6.48346 3.98504 4.97382 4.7041 4.25476C5.42316 3.53569 6.93281 4.01262 7.81738 3.64662C8.73437 3.26722 9.47239 1.875 10.4494 1.875C11.4263 1.875 12.1643 3.26722 13.0813 3.64663C13.9659 4.01262 15.4755 3.5357 16.1946 4.25476C16.9136 4.97382 16.4367 6.48346 16.8027 7.36804C17.1821 8.28503 18.5743 9.02305 18.5743 10C18.5743 10.977 17.1821 11.715 16.8027 12.632C16.4367 13.5165 16.9136 15.0262 16.1946 15.7452C15.4755 16.4643 13.9659 15.9874 13.0813 16.3534C12.1643 16.7328 11.4263 18.125 10.4493 18.125C9.47235 18.125 8.73434 16.7328 7.81737 16.3534C6.9328 15.9874 5.42316 16.4643 4.7041 15.7452Z", fill: "url(#id-40a)" }),
    React.createElement("path", { d: "M12.9493 8.75L9.61599 12.5L7.94934 10.625", stroke: "#fff", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "linearGradient",
        { id: "id-40a", x1: "2.949", y1: "15", x2: "18.949", y2: "-2.5", gradientUnits: "userSpaceOnUse" },
        React.createElement("stop", { stopColor: "#1BCAD9" }),
        React.createElement("stop", { offset: "1", stopColor: "#1799A4" })
      )
    )
  );
});